/**
 * @generated SignedSource<<4d3b6149defd652fbd87cbdd7c92b70c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpsertGroupPostInput = {
  clientMutationId?: string | null | undefined;
  content: string;
  groupId: string;
  id?: string | null | undefined;
  title?: string | null | undefined;
};
export type UpsertGroupPostMutation$variables = {
  input: UpsertGroupPostInput;
};
export type UpsertGroupPostMutation$data = {
  readonly upsertGroupPost: {
    readonly groupPostEdge: {
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"GroupPostsEditDialog_post" | "GroupPostsListItem_post">;
      } | null | undefined;
    };
  } | null | undefined;
};
export type UpsertGroupPostMutation = {
  response: UpsertGroupPostMutation$data;
  variables: UpsertGroupPostMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 5
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rootParentCommentId",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 3
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Notification",
  "kind": "LinkedField",
  "name": "notification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "read",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "fromNow"
    }
  ],
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": "createdAt(format:\"fromNow\")"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 1
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": (v13/*: any*/),
      "concreteType": "LikeConnection",
      "kind": "LinkedField",
      "name": "likes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LikeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Like",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/)
                  ],
                  "storageKey": null
                },
                (v2/*: any*/),
                (v12/*: any*/)
              ],
              "storageKey": null
            },
            (v14/*: any*/)
          ],
          "storageKey": null
        },
        (v15/*: any*/)
      ],
      "storageKey": "likes(last:1)"
    },
    {
      "alias": null,
      "args": (v13/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "LikesList_likes",
      "kind": "LinkedHandle",
      "name": "likes"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likedByMe",
      "storageKey": null
    }
  ],
  "type": "Likeable",
  "abstractKey": "__isLikeable"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertGroupPostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertGroupPostPayload",
        "kind": "LinkedField",
        "name": "upsertGroupPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupPostEdge",
            "kind": "LinkedField",
            "name": "groupPostEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupPost",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "GroupPostsEditDialog_post"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "GroupPostsListItem_post"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpsertGroupPostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertGroupPostPayload",
        "kind": "LinkedField",
        "name": "upsertGroupPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupPostEdge",
            "kind": "LinkedField",
            "name": "groupPostEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupPost",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "GroupPostCommentConnection",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GroupPostCommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GroupPostComment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": (v6/*: any*/),
                                "concreteType": "GroupPostCommentConnection",
                                "kind": "LinkedField",
                                "name": "replies",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GroupPostCommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "GroupPostComment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v5/*: any*/),
                                          (v3/*: any*/),
                                          (v7/*: any*/),
                                          (v8/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          (v16/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v15/*: any*/)
                                ],
                                "storageKey": "replies(last:3)"
                              },
                              {
                                "alias": null,
                                "args": (v6/*: any*/),
                                "filters": null,
                                "handle": "connection",
                                "key": "GroupPostCommentsListItem_replies",
                                "kind": "LinkedHandle",
                                "name": "replies"
                              },
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": "comments(last:5)"
                  },
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "GroupPostCommentsList_comments",
                    "kind": "LinkedHandle",
                    "name": "comments"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groupId",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v7/*: any*/),
                  (v11/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "893af333589346325bc844cab420aa4b",
    "id": null,
    "metadata": {},
    "name": "UpsertGroupPostMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertGroupPostMutation(\n  $input: UpsertGroupPostInput!\n) {\n  upsertGroupPost(input: $input) {\n    groupPostEdge {\n      node {\n        ...GroupPostsEditDialog_post\n        ...GroupPostsListItem_post\n        id\n      }\n    }\n  }\n}\n\nfragment Avatar_user on User {\n  displayName\n  photoURL\n}\n\nfragment GroupMemberBadges_user on User {\n  role\n}\n\nfragment GroupPostCommentsListItemNoReplies_comment on GroupPostComment {\n  ...GroupPostCommentsListItem_comment_3Tq2Ec\n}\n\nfragment GroupPostCommentsListItemWithReplies_comment on GroupPostComment {\n  ...GroupPostCommentsListItem_comment_ePDSa\n}\n\nfragment GroupPostCommentsListItem_comment_3Tq2Ec on GroupPostComment {\n  ...Likeable_likeable\n  ...GroupPostsCommentForm_comment\n  id\n  content\n  notification {\n    userId\n    read\n    id\n  }\n  createdAt(format: \"fromNow\")\n  author {\n    ...Avatar_user\n    ...GroupMemberBadges_user\n    displayName\n    role\n    id\n  }\n}\n\nfragment GroupPostCommentsListItem_comment_ePDSa on GroupPostComment {\n  ...Likeable_likeable\n  ...GroupPostsCommentForm_comment\n  id\n  content\n  replies(last: 3) {\n    edges {\n      node {\n        id\n        ...GroupPostCommentsListItemNoReplies_comment\n        ...GroupPostsCommentForm_comment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  notification {\n    userId\n    read\n    id\n  }\n  createdAt(format: \"fromNow\")\n  author {\n    ...Avatar_user\n    ...GroupMemberBadges_user\n    displayName\n    role\n    id\n  }\n}\n\nfragment GroupPostCommentsList_post on GroupPost {\n  id\n  comments(last: 5) {\n    edges {\n      node {\n        ...GroupPostCommentsListItemWithReplies_comment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment GroupPostMenu_post on GroupPost {\n  ...GroupPostsEditDialog_post\n  id\n  groupId\n}\n\nfragment GroupPostsCommentForm_comment on GroupPostComment {\n  id\n  rootParentCommentId\n}\n\nfragment GroupPostsCommentForm_post on GroupPost {\n  id\n}\n\nfragment GroupPostsEditDialog_post on GroupPost {\n  id\n  title\n  content\n}\n\nfragment GroupPostsListItem_post on GroupPost {\n  ...GroupPostsCommentForm_post\n  ...GroupPostCommentsList_post\n  ...Likeable_likeable\n  ...GroupPostMenu_post\n  id\n  title\n  content\n  createdAt(format: \"fromNow\")\n  groupId\n  notification {\n    userId\n    read\n    id\n  }\n  author {\n    ...Avatar_user\n    ...GroupMemberBadges_user\n    id\n    role\n    displayName\n  }\n}\n\nfragment LikeListItem_like on Like {\n  author {\n    id\n    ...Avatar_user\n  }\n}\n\nfragment Likeable_likeable on Likeable {\n  __isLikeable: __typename\n  ...LikesList_likeable\n  ...LikesButton_likeable\n}\n\nfragment LikesButton_likeable on Likeable {\n  __isLikeable: __typename\n  id\n  likedByMe\n}\n\nfragment LikesList_likeable on Likeable {\n  __isLikeable: __typename\n  likes(last: 1) {\n    totalCount\n    edges {\n      node {\n        ...LikeListItem_like\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5b75b0ffa463cedc633233f3d12593e";

export default node;
